import React from 'react';
import PropTypes from 'prop-types';

export default class InitialsBubble extends React.Component {
  static propTypes = {
    preview: PropTypes.bool,
    text: PropTypes.string
  };

  render() {
    return (
      <div className={`${this.props.preview ? 'preview' : 'initials'}-bubble`}>
        <div className="text">{this.props.text}</div>
      </div>
    );
  }
}
